import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const CategoryItem = ({ postName, postDescription, iconClass }) => (
  <Link to={`/cms/structure/${postName}`}>
    <div className={`flex bg-greyFilterItems bg-opacity-100 h-100px mb-2 rounded`}>
      <div className="drag-box w-12 bg-greyFilterItems p-2 flex items-center justify-center cursor-move text-greyFilter w-100px text-30 rounded-l">=</div>
      <div className="flex cursor-pointer items-center">
        <div className={`img bg-${postName} overflow-hidden bg-white w-123px justify-center self-stretch items-center flex`}>
          { postDescription.image && postDescription.image.en ?
            <img className="object-cover h-100px w-full" src={`${postDescription.image.en}`} />
          :
            <span className={`font-icon ${iconClass}  text-black text-80`} />
          }
        </div>
        <div className="title pl-4 self-center font-semibold text-black capitalize">{postName}</div>
      </div>
    </div>
  </Link>
);

CategoryItem.propTypes = {
  iconClass: PropTypes.string,
  postName: PropTypes.string,
};

CategoryItem.defaultProps = {
  iconClass: '',
  postName: '',
};

export default CategoryItem;
